import { DialogActions } from "@material-ui/core";
import { useFormikContext } from "formik";
import React, { useState } from "react";
import DialogLayout from "../../../../../../partials/content/DialogLayout";
import {
  FormDateField,
  FormTextField,
} from "../../../../../../partials/content/Forms/FormField";
import SearchCurrency from "../../../../setup/finance/searchCurrency";

function DirectSalesHeader(props) {
  const [openSearchCurrency, setOpenSearchCurrency] = useState(false);
  const { values, setFieldValue } = useFormikContext();
  return (
    <React.Fragment>
      <div className="row">
        <div className="col-sm-6 col-md-6 col-lg-6">
          {values.customerID > 0 ? (
            <FormTextField label="Customer Name" name="customerName" readonly />
          ) : values.leadID > 0 ? (
            <FormTextField label="Lead" name="leadName" readonly />
          ) : null}
          <FormTextField
            label="Currency"
            name="currencyCode"
            readonly
            searchButton
            onSearchClick={() => {
              setOpenSearchCurrency(true);
            }}
          />
        </div>
        <div className="col-sm-6 col-md-6 col-lg-6">
          <FormDateField label="Sales Date" name="salesDate" />
          <FormTextField
            label="Exchange Rate To Base Currency"
            name="exRateToBaseCurr"
            readonly
          />
        </div>
      </div>
      <DialogLayout
        open={openSearchCurrency}
        title="Search Currency"
        onCloseDialog={() => {
          setOpenSearchCurrency(false);
        }}
        maxWIdth="sm"
      >
        <SearchCurrency
          onSelectCurrency={(currency) => {
            setFieldValue("exRateToBaseCurr", currency.exRateToBaseCurr);
            setFieldValue("exRateToForeignCurr", currency.exRateToForeignCurr);
            setFieldValue("currencyID", currency.ID);
            setFieldValue("currencyCode", currency.currencyCode);
            setOpenSearchCurrency(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchCurrency(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );
}

export default DirectSalesHeader;
